<h1 mat-dialog-title>
  {{ T.MH.SETTINGS | translate }}
</h1>

<mat-dialog-content>
  <formly-form
    (modelChange)="onModelChange($event)"
    [fields]="fields"
    [form]="form"
    [model]="entityData"
  >
  </formly-form>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <div class="wrap-buttons">
    <button
      (click)="cancelEdit()"
      class="btn btn-primary submit-button"
      color="primary"
      mat-button
      type="button"
    >
      {{ T.G.CANCEL | translate }}
    </button>
    <button
      (click)="done()"
      class="btn btn-primary submit-button"
      color="primary"
      mat-stroked-button
      type="button"
    >
      {{ T.G.CLOSE | translate }}
    </button>
  </div>
</mat-dialog-actions>
